import React from 'react';
import ContactForm from '../Components/ContactForm/ContactForm';
import gitIcon from '../Components/Assets/github-mark.png';
import lIIcon from '../Components/Assets/LI-In-Bug.png';

export const Contact = () => {
  return (
    <main className="grid">
      <div className="Kontakt-Kontakt">

        {/* Toptekst */}
        <div className="kontaktText">
          <h2>Kontakt mig</h2>
          <p>
            Tak fordi du har taget dig tid til at se min hjemmeside, mit CV og min portefølje.<br />
            Hvis du har spørgsmål, ønsker en samtale eller overvejer at ansætte mig, <br />
            kan du enten sende mig en besked i kontaktformularen eller kontakte mig direkte.
          </p>
        </div>

        {/* Højre kolonne */}
        <div className="kontaktForm">
          <section>
            <ContactForm title="Kontaktformular" showNote />
          </section>
        </div>

        {/* Venstre kolonne */}
        <div className="kontaktInfo div-center">
          <h3>Kontaktinformation</h3>
          <p><strong>E-mail:</strong> <a href="mailto:larsgregersen1990@gmail.com">larsgregersen1990@gmail.com</a></p>
          <p><strong>Mobil:</strong> <a href="tel:+4560227681">+45 60 22 76 81</a></p>

          <div className="social-icons">
            <a href="https://github.com/LSchouG" target="_blank" rel="noopener noreferrer">
              <img src={gitIcon} alt="GitHub" />
            </a>
            <a href="https://www.linkedin.com/in/lars-schou-gregersen-18b477248/" target="_blank" rel="noopener noreferrer">
              <img src={lIIcon} alt="LinkedIn" />
            </a>
            <a href="/uploads/Lars-Gregersen-CV.pdf" download className="cv-icon">
              CV
            </a>
          </div>
        </div>
      </div>
    </main>

  );
};

